import componentHelpers from '../componentLibrary/componentHelpers.js'
import * as $ from 'jquery';

class NextButtonService {

    eventBroker;
    selector;
    params;
    $buttonBox;
    $button;
    nextButtonEnabled = true;
    hasNextButton = true;
    nextButtonDelay = 500;

    constructor(progressbarSelector, eventBroker) {
        this.selector = progressbarSelector;
        this.eventBroker = eventBroker;
    }

    init(nextButtonDelay, params) {
        this.nextButtonDelay = nextButtonDelay;
        this.params = params;

        this.eventBroker.subscribe("showNextButtonEvent", (params) => {
            this.onShowNextButton(params)
        });

        this.eventBroker.subscribe("readyToShowEvent", this.listenToButtons.bind(this))

        // A component can show the button inside its own view, see ButtonRow.onNodeShown
        this.eventBroker.subscribe("placeNextButtonEvent", ($target) => {
            $target.append(this.$buttonBox);
        });

        // Back below the dialog as soon as the next node starts showing, also for nodes that
        // jump on (goto) and never ask for the button, so it isn't left in a hidden question
        this.eventBroker.subscribe("showingNodeEvent", () => {
            if (this.$buttonBox.parent()[0] !== $(this.selector)[0])
                $(this.selector).append(this.$buttonBox);
        });

        let $nextButtonContainer = $(this.selector);

        $nextButtonContainer.append(this.getNextButton());
    }

    onShowNextButton(params) {
        this.$button.text(params.buttontext);
        this.$button.data("id", params.nodeId);

        this.nextButtonEnabled = params.nextButtonEnabled;
        this.hasNextButton = params.hasNextButton;

        this.setButtonState(params.nodeId);
    }

    getNextButton() {
        var $buttonbox = $("<div class='sid-next-button-box'></div>");
        var $buttonwrapper = $("<div class='sid-navigation-wrapper sid-text-center'></div>");
        let cssClasses = "btn btn-primary text-uppercase text-light fw-bold fs-button-small next-button";
        var $button = $(`<button type='button' class='${cssClasses}' ${this.nextButtonEnabled ? '' : 'disabled'} data-id='0'>"DEFAULT"</button>`);

        $button.click(function (e) {
            $(e.currentTarget).prop('disabled', true);
            var nodeId = $(e.currentTarget).data("id");
            let $spinner = $(`<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden"></span></div>`);
            $spinner.find("span").text(componentHelpers.uiText({ params: this.params }, "si_pts_dialog_loading", "Loading…"));
            $(e.currentTarget).empty().append($spinner);
            setTimeout(() => {
                this.eventBroker.fire("nexButtonClickedEvent", nodeId);
            }, this.nextButtonDelay);
        }.bind(this));

        this.eventBroker.subscribe("enableNextButtonEvent", function (params) {
            this.nextButtonEnabled = true;
            this.setButtonState(params);
        }.bind(this));

        this.eventBroker.subscribe("disableNextButtonEvent", function (params) {
            this.nextButtonEnabled = false;
            this.setButtonState(params);
        }.bind(this));

        $buttonwrapper.append($button);
        $buttonbox.append($buttonwrapper);

        this.$button = $button;
        this.$buttonBox = $buttonbox;
        return $buttonbox;
    }

    setButtonState(nodeId) {
        let text = this.$button.text();

        if (this.hasNextButton && text)
            $(".next-button").show();
        else
            $(".next-button").hide();

        if (this.nextButtonEnabled) {
            $(".next-button").removeClass("inactive").removeAttr("disabled");
            $(`#component_id_${nodeId}`).parents(".sid-sub-frame").find(".internal-next-button").removeClass("inactive").removeAttr("disabled");
        }
        else {
            $(".next-button").addClass("inactive").attr("disabled", true);
            $(`#component_id_${nodeId}`).parents(".sid-sub-frame").find(".internal-next-button").addClass("inactive").attr("disabled", true);
        }
    }

    listenToButtons() {
        $(".internal-next-button").one("click", function (e) {
            $(".next-button").trigger("click");
        });
    }
}

export { NextButtonService }
